import {GUIDE_MODE, BATCH_TIPS_MODE, TRAIN_MODE, ZINDEX_FOCUS_COVER, OPACITY_FOCUS_COVER} from '../lib/constant';
import actions from './actions/actions';
import {setStepMode, setStepProgress, setChatSteps, setChatButtons} from '../reducers/teach';
import {renderConfirmModal} from '../components/confirm-modal/confirm-modal';
import ScratchBlocks from 'scratch-blocks';
import bindAll from 'lodash.bindall';
import Audio from '../lib/audio';
import event, {EVENTS} from '../lib/event';
import {renderCover} from '../lib/utils';
import stageMode from './actions/stage-mode';
import {saveProjectAsCopy} from '../../reducers/project-state';

const finishName = 'finish';
const selfName = 'self';
const finishIndex = -1;

/**
 * 底部交互按钮
 * @type {{}}
 */
const BUTTONS = {
    CONTINUE: {
        button: '下一步', event: EVENTS.STEP_CONTINUE, style: 'focus'
    },
    FINISH: {
        button: '完成', event: EVENTS.STEP_CONTINUE, style: 'focus'
    },
    SHOW_TIPS: {
        button: '提示我', event: EVENTS.STEP_SHOW_TIPS
    },
    ENTER_GUIDE_MODE: {
        button: '引导我', event: EVENTS.STEP_ENTER_GUIDE_MODE
    },
    REENTER_GUIDE_MODE: {
        button: '重新引导', event: EVENTS.STEP_ENTER_GUIDE_MODE
    },
    EXIT_GUIDE_MODE: {
        button: '退出引导', event: EVENTS.STEP_EXIT_GUIDE_MODE
    },
    BACK_TO_STUDY: {
        button: '返回学习模式', event: EVENTS.TASK_BACK_TO_STUDY
    }
}

/**
 * 将Tips转化为card对象
 * @param tips
 */
const tipsToCard = (actionIndex, tips) => {
    let lines = [];
    if (typeof(tips) == 'string') {
        lines = [{text: tips}];
    }else if (typeof(tips) == 'object') {
        for (let i = 0; i < tips.length; ++i) {
            if (typeof(tips[i]) == 'string') {
                if (!(tips[i][0] === '/' && tips[i][1] === '/' && tips[i][2] !== '/')) {
                    lines.push({text: tips[i]});
                }
            }else {
                lines.push(tips[i]);
            }
        }
    }else {
        lines = [{text: typeof(tips)}];
    }
    return {actionIndex, lines};
}

const cardToText = card => {
    let text = '';
    for (let i = 0; i < card.lines.length; ++i) {
        if (card.lines[i].text) text += card.lines[i].text;
    }
    return text;
}

/**
 * 两个对象相同，返回true
 * @param oldData
 * @param newData
 * @returns {boolean}
 */
const compareObject = function (oldData, newData) {
    if (oldData === newData) return true;
    const arg = Array.prototype.slice.call(arguments);
    const objCall = (obj, string) => Object.prototype.toString.call(obj) === `[object ${string}]`;
    if (arg.every(obj => objCall(obj, 'Object')) && Object.keys(oldData).length === Object.keys(newData).length) {
        for (const key in oldData) { if (oldData.hasOwnProperty(key) && !compareObject(oldData[key], newData[key])) return false; }
    } else if (arg.every(obj => objCall(obj, 'Array')) && oldData.length === newData.length) {
        for (const key in oldData) { if (!compareObject(oldData[key], newData[key])) return false; }
    } else {
        return false;
    }
    return true;
};

const cardToSpeak = (card) => {
    Audio.tts(cardToText(card));
}

class StepsRuntime {

    constructor () {
        bindAll(this, [
            'handleContinue',
            'handleShowTips',
            'handleEnterGuideMode',
            'handleExitGuideMode',
            'doValidate',
            'goNext',
            'doResumeGuide',
            'doResumeTrain',
            'doRunStepWithGuideMode',
            'doRunStep',
            'doGoNext'
        ]);
        this.init();
        this.attachEvents();
    }

    init() {
        this.blocksMap = new Map();
        this.mode = TRAIN_MODE; //默认是非手把手引导模式
        this.isGuideContinueStep = false; //进入引导模式后，是否跨Step持续引导
        this.isShowTips = false; //在Train模式下，是否显示提示
        this.steps = [];
        this.cardId = 0; //卡片的自增长id
        this.stepIndex = 0;
        this.actionIndex = -1;
        this.lastActionRes = undefined; //前一个action的返回值
        this.chatSteps = []; //聊天窗口中的卡片数据
        this.buttons = []; //聊天窗口下面的按钮
        this.lastButtons = []; //保存上一组按钮，以便恢复
        this.isActionRunning = false; //当前步骤是否没有运行结束
        this.currentInit = 0; //最后的初始化项目id
        this.modifiedProjectId = '0'; //当前载入的改编项目的ID
        this.guideId = 0; //当前载入脚本的guide_id
        /*
        this.guideShot = {}; //引导模式下的状态快照
        this.trainShot = {};
         */
    }

    reset() {
        this.init();
        event.emit(EVENTS.CLEAR_COVER);
        event.off(EVENTS.PROJECT_LOADED_FINISH, this.doResumeGuide);
        event.off(EVENTS.PROJECT_LOADED_FINISH, this.doResumeTrain);
        event.off(EVENTS.PROJECT_LOADED_FINISH, this.doRunStepWithGuideMode);
        event.off(EVENTS.PROJECT_LOADED_FINISH, this.doRunStep);
        event.off(EVENTS.PROJECT_UPDATED_FINISH, this.doGoNext);
        event.off(EVENTS.PROJECT_CREATED_FINISH, this.doGoNext);

        window.store.dispatch(setStepMode(this.mode));
        window.store.dispatch(setStepProgress(0));
        window.store.dispatch(setChatButtons(this.buttons));
        window.store.dispatch(setChatSteps(this.chatSteps));
        if (ScratchBlocks.getMainWorkspace() && ScratchBlocks.getMainWorkspace().getToolbox()) {
            window.toolbox = ScratchBlocks.getMainWorkspace().getToolbox();
        }

        if (ScratchBlocks.getMainWorkspace() && ScratchBlocks.getMainWorkspace().scrollbar) {
            window.scrollbar = ScratchBlocks.getMainWorkspace().scrollbar;
        }
    }

    /**
     * dump当前runtime的状态
     */
    dumpState() {
        if (this.chatSteps.length > 0) {
            const {...data} = this;
            return JSON.stringify(data);
        }else {
            return '';
        }
    }

    setMode(mode) {
        this.mode = mode;
        window.store.dispatch(setStepMode(this.mode));
    }
    /**
     * 从dump的state数据恢复
     * @param state
     */
    restoreState(state) {
        this.reset();
        if (typeof(state) === 'string')
            state = JSON.parse(state);
        for (let key in state.blocksMap) {
            this.blocksMap.set(key, state.blocksMap[key]);
        }
        this.setMode(state.mode);
        this.isGuideContinueStep = state.isGuideContinueStep;
        this.isShowTips = state.isShowTips;
        this.steps = state.steps;
        this.cardId = state.cardId;
        this.stepIndex = state.stepIndex;
        this.actionIndex = state.actionIndex;
        this.lastActionRes = state.lastActionRes;
        this.chatSteps = state.chatSteps;
        this.buttons = state.buttons;
        this.lastButtons = state.lastButtons;
        this.currentInit = state.currentInit;
        if (state.guideId) this.guideId = state.guideId;
        /*
        this.guideShot = state.guideShot || {};
        this.trainShot = state.trainShot || {};

         */

        window.store.dispatch(setStepMode(this.mode));
        window.store.dispatch(setStepProgress(this.getProgress()));
        window.store.dispatch(setChatButtons(this.buttons));
        window.store.dispatch(setChatSteps(this.chatSteps));
        this.resume();
    }

    /**
     * 保存状态快照
     */
    snapShot() {
        const {steps, guideShot, trainShot, ...shotData} = this;
        shotData.vmState = window.vm.toJSON();
        shotData.chatSteps = [...this.chatSteps];
        if (this.mode == TRAIN_MODE) {
            this.trainShot = shotData;
        }else {
            this.guideShot = shotData;
        }
    }

    /**
     * 从快照恢复
     */
    restoreSnapShot(mode) {
        let shotData;
        if (mode == TRAIN_MODE) {
            shotData = this.trainShot;
        }else {
            shotData = this.guideShot;
        }
        window.vm.loadProject(shotData.vmState);
        this.restoreState(shotData);
    }

    /**
     * 是否已经开始引导
     * @returns {[]|*|boolean}
     */
    isStarted() {
        return this.chatSteps.length > 0;
    }

    /**
     * 是否已经结束引导
     * @returns {[]|*|boolean}
     */
    isFinished() {
        return this.steps && this.stepIndex === finishIndex;
    }


    //继续引导模式
    doResumeGuide() {
        this.enterGuideMode();
    }

    //继续练习模式
    doResumeTrain() {
        setTimeout(() => {
            console.log('loaded_ 1')
            if (this.actionIndex > -1) {
                this.showButtons([{...BUTTONS.REENTER_GUIDE_MODE, stepIndex: this.stepIndex}]);
            }else {
                this.showButtons([]);
            }
            this.addContinueButton();
            this.runStep(TRAIN_MODE); //如果上次结束时为练习模式，强制以练习模式运行
        }, 500)
    }
    /**
     * 恢复运行，比如重新载入页面时从历史记录开始运行
     */
    resume() {
        //不匹配的情况，恢复到第一步
        if (this.stepIndex >= this.steps.length) {
            this.stepIndex = 0;
            this.actionIndex = -1;
        }
        if (this.stepIndex == finishIndex) { //已经引导完的情况，切换到练习模式
            this.actionIndex = -1;
            this.setMode(TRAIN_MODE);
        }
        if (this.actionIndex > -1 && (!this.steps[this.stepIndex].actions || this.actionIndex >= this.steps[this.stepIndex].actions.length)) {
            this.actionIndex = -1;
        }
        if (this.mode === GUIDE_MODE) {
            /*
            this.setMode(TRAIN_MODE);
            this.showButtons([BUTTONS.CONTINUE]);
            this.loadModifiedProject();

             */
            if (this.steps[this.stepIndex].init === undefined) {
                event.once(EVENTS.PROJECT_LOADED_FINISH, this.doResumeGuide);
                this.loadModifiedProject();
            }else {
                this.enterGuideMode();
            }
        }else {
            if (!this.isFinished()) {
                event.once(EVENTS.PROJECT_LOADED_FINISH, this.doResumeTrain);
            }else {
                //最后一步有引导步骤
                if (this.steps && this.steps.length > 0 && this.steps[this.steps.length - 1].actions && this.steps[this.steps.length - 1].actions.length > 0) {
                    this.showButtons([{...BUTTONS.REENTER_GUIDE_MODE, stepIndex: this.steps.length - 1}]);
                }
                if (!this.hasButton(BUTTONS.FINISH)) {
                    this.addButtons([BUTTONS.FINISH]);
                }
            }
            this.loadModifiedProject();
        }
    }

    run(steps, mode) {
        if (!Array.isArray(steps)) {
            console.error('steps必需为数组');
            return false;
        }
        this.reset();
        this.guideId = steps[0].guideId;
        if (mode !== undefined) {
            this.setMode(mode);
        }
        if (steps[0].manifest) { //去除manifest的步骤
            steps.shift();
        }
        if (steps[0].init === undefined) {
            console.warn('兼容旧版本引导');
            steps = [{
                step: '兼容旧版本引导',
                mode: GUIDE_MODE, //自动进入引导模式
                actions: steps
            }];
        }
        this.steps = steps;
        if (this.steps.length > 0) {
            setTimeout(() => {
                this.runStep();
            }, 500);

            /*
            if (this.mode === TRAIN_MODE && this.steps[0].mode != GUIDE_MODE) { //练习模式，载入历史项目
                event.once(EVENTS.PROJECT_LOADED_FINISH, () => {
                    setTimeout(() => {
                        console.log('loaded_ 2')
                        this.runStep();
                    }, 500)
                })
                this.loadModifiedProject();
            }else {
                setTimeout(() => {
                    this.runStep();
                }, 500);
            }*/
        }
        return true;
    }

    /**
     * 开始监听UI交互事件
     */
    attachEvents() {
        event.on(EVENTS.STEP_CONTINUE, this.handleContinue);
        event.on(EVENTS.STEP_SHOW_TIPS, this.handleShowTips);
        event.on(EVENTS.STEP_EXIT_GUIDE_MODE, this.handleExitGuideMode);
        event.on(EVENTS.STEP_ENTER_GUIDE_MODE, this.handleEnterGuideMode);
        event.on(EVENTS.GAME_EVENT, this.doValidate);
    }

    /**
     * 停止监听UI交互事件
     */
    detachEvents() {
        event.off(EVENTS.STEP_CONTINUE, this.handleContinue);
        event.off(EVENTS.STEP_SHOW_TIPS, this.handleShowTips);
        event.off(EVENTS.STEP_EXIT_GUIDE_MODE, this.handleExitGuideMode);
        event.off(EVENTS.STEP_ENTER_GUIDE_MODE, this.handleEnterGuideMode);
        event.off(EVENTS.GAME_EVENT, this.doValidate);
    }

    /**
     * 在聊天框底部显示一组交互按钮
     * @param buttons
     */
    showButtons(buttons) {
        this.lastButtons = this.buttons;
        this.buttons = buttons;
        window.store.dispatch(setChatButtons(this.buttons));
    }

    /**
     * 添加按钮
     * @param buttons
     */
    addButtons(buttons) {
        this.buttons = [...this.buttons, ...buttons];
        window.store.dispatch(setChatButtons(this.buttons));
    }

    addContinueButton() {
        if (this.stepIndex == finishIndex || this.getNextIndex().stepIndex == finishIndex) {
            if (!this.hasButton(BUTTONS.FINISH)) {
                this.addButtons([BUTTONS.FINISH]);
            }
        }else {
            if (!this.hasButton(BUTTONS.CONTINUE)) {
                this.addButtons([BUTTONS.CONTINUE]);
            }
        }
    }

    /**
     * 判断是否已经存在某个按钮
     * @param button
     * @returns {boolean}
     */
    hasButton(button) {
        for (let i = 0; i < this.buttons.length; ++i) {
            if (this.buttons[i].event === button.event) {
                return true;
            }
        }
        return false;
    }

    doGoNext() {
        event.off(EVENTS.PROJECT_CREATED_FINISH, this.doGoNext);
        event.off(EVENTS.PROJECT_UPDATED_FINISH, this.doGoNext);
        if (this.goNextTimeoutId) {
            clearTimeout(this.goNextTimeoutId);
            this.goNextTimeoutId = undefined;
        }
        setTimeout(() => {
            this.goNext();
        }, 500);
    }
    /**
     * 「继续」按钮被点击
     */
    handleContinue() {
        //如果有validator，点击下一步时提示必须完成挑战
        if (this.getNextIndex().stepIndex !== this.stepIndex && this.currentStep() && this.currentStep().validator && !this.currentStep().validated) {
            this.showError('需要点击小绿旗运行程序，成功完成当前任务挑战，才能进入下一步哦，加油！');
            return;
        }
        //引导模式走到当前step的最后一个action以后，退出引导模式
        if (this.mode === GUIDE_MODE && !this.isGuideContinueStep && this.getNextIndex().stepIndex !== this.stepIndex) {
            this.exitGuideMode();
            /*
            //等待退出引导模式项目保存完成后，再继续下一步
            event.once(EVENTS.PROJECT_UPDATED_FINISH, this.doGoNext);
            event.once(EVENTS.PROJECT_CREATED_FINISH, this.doGoNext);
            this.goNextTimeoutId = setTimeout(this.doGoNext, 10000); //10秒还没有保存成功，直接进入下一步

             */
        }
        this.goNext();
    }

    /**
     * 「提示我」按钮被点击
     */
    handleShowTips({stepIndex}) {
        this.moreTips(stepIndex);
    }

    /**
     * 「手把手教我」按钮被点击
     */
    handleEnterGuideMode({stepIndex}) {
        if (this.mode == GUIDE_MODE) {
            if (this.hasButton(EVENTS.STEP_CONTINUE)) {
                showMessage('当前已经处于引导模式，请点击聊天框下面的按钮继续。');
            }else {
                showMessage('当前已经处于引导模式，请按提示完成相应步骤');
            }
            return;
        }
        if (stepIndex >= this.steps.length) {
            showMessage('步骤索引超出范围，无法进入引导模式');
            return;
        }
        /*
        if (stepIndex != undefined && stepIndex != this.stepIndex) {
            renderConfirmModal({
                title: '此为历史步骤，不能进入引导模式，只能在最新的步骤中进入引导模式',
                confirmText: '确认',
                onConfirm: () => {
                    //do nothing
                }
            });
            return;
        }
         */
        const step = this.steps[stepIndex];
        //进入引导模式的前提是必须要有可引导的步骤，并且项目已经有发生修改
        if (window.store.getState().scratchGui.projectChanged && step.init !== undefined) {
            if (step.actions || step.action) {
                renderConfirmModal({
                    title: '即将进入引导模式，当前改编的项目将被覆盖为标准版本。确认要进入引导模式吗？',
                    closeText: '确认',
                    confirmText: '取消',
                    onClose: () => {
                        this.stepIndex = stepIndex;
                        this.enterGuideMode();
                    },
                    onConfirm: () => {
                        //do nothing
                    }
                });

            }else {
                this.showError('当前步骤不存在actions，无法进入手把手引导模式');
            }
        }else {
            this.stepIndex = stepIndex;
            this.enterGuideMode();
        }

    }

    doRunStepWithGuideMode() {
        setTimeout(() => {
            this.runStep(GUIDE_MODE);
        }, 500);
    }

    doRunStep() {
        setTimeout(() => {
            this.runStep();
        }, 500);
    }
    /**
     * 进入引导模式
     */
    enterGuideMode() {

        this.setMode(GUIDE_MODE); //切换到引导模式
        /*
        if (this.guideShot.stepIndex == this.stepIndex) { //有历史状态，直接从历史状态加载
            window.vm.loadProject(this.guideVMState);
            setTimeout(() => this.runStep());
        }else {

         */

        //回退tips的步骤
        if (this.chatSteps.length > this.stepIndex) {
            this.chatSteps.length = this.stepIndex + 1;
            for (let i = this.chatSteps[this.stepIndex].cards.length - 1; i > 0; --i) {
                if (this.chatSteps[this.stepIndex].cards[i].actionIndex > -1) {
                    this.chatSteps[this.stepIndex].cards.pop();
                }else {
                    break;
                }
            }
            const firstCard = this.chatSteps[this.stepIndex].cards[0];
            for (let i = firstCard.lines.length - 1; i >= 0; --i) {
                if (firstCard.lines[i].buttons) {
                    for (let j = firstCard.lines[i].buttons.length - 1; j >= 0; --j) {
                        if (firstCard.lines[i].buttons[j].event === EVENTS.STEP_ENTER_GUIDE_MODE) {
                            firstCard.lines[i].buttons[j] = {...firstCard.lines[i].buttons[j], ...BUTTONS.REENTER_GUIDE_MODE};
                            firstCard.lines[i] = {...firstCard.lines[i]};
                            break;
                        }
                    }
                    break;
                }
            }
            this.chatSteps[this.stepIndex].cards[0] = {...firstCard};

            this.chatSteps[this.stepIndex] = {...this.chatSteps[this.stepIndex]};
            this.chatSteps[this.stepIndex].cards = [...this.chatSteps[this.stepIndex].cards];
            window.store.dispatch(setChatSteps([...this.chatSteps]));
            this.actionIndex = 0;
        }else { //尚未生成step的tips的情况
            this.actionIndex = -1;
        }

        if (this.steps[this.stepIndex].init !== undefined) {
            event.once(EVENTS.PROJECT_LOADED_FINISH, this.doRunStepWithGuideMode);
            this.loadInitProject(this.stepIndex);
        }else {
            setTimeout(() => {
                this.runStep(GUIDE_MODE);
            }, 500)
        }
    }

    /**
     * 「停止引导」按钮被点击，切换回练习模式
     */
    handleExitGuideMode() {
        renderConfirmModal({
            title: '即将退出引导模式',
            closed: true,
            closeText: '取消',
            confirmText: '确定',
            onClose: () => {
                //DO NOTHING
            },
            onConfirm: () => {
                this.exitGuideMode();
            }
        });


        /*
        renderConfirmModal({
            title: '结束当前步骤的引导，接下来你可以选择：',
            msg: '在进入引导模式之前，已经自动为你保存了一份你之前改编的项目，你可以恢复回到之前的那个项目，或者继续保持当前引导完成的项目',
            closed: true,
            closeText: '取消',
            confirmText: '恢复之前项目',
            confirmText2: '使用当前项目',
            onClose: () => {
                if (this.isActionRunning) { //当前步骤正在运行尚未退出，遮罩会被破坏，需要重新运行
                    this.runStep();
                }
            },
            onConfirm: () => { //恢复之前项目
                this.setMode(TRAIN_MODE); //切换到练习模式
                this.stepAbort();
                this.showButtons([]);
                this.addContinueButton();
                if (finished) {
                    event.once(EVENTS.PROJECT_LOADED_FINISH, () => {
                        setTimeout(() => {
                            console.log('loaded_ 4')
                            this.goNext(TRAIN_MODE);
                        }, 500);
                    });
                }
                this.loadModifiedProject();
            },
            onConfirm2: () => { //保留当前项目
                this.setMode(TRAIN_MODE); //切换到练习模式
                this.stepAbort();
                this.showButtons([]);
                this.addContinueButton();
                if (finished) {
                    event.once(EVENTS.TASK_GUIDE_PROJECT_SAVED, () => {
                        this.goNext(TRAIN_MODE);
                    });
                }
                this.saveProjectToModifiedProject(); //将当前项目覆盖到自己的副本

            }
        })

         */
    }

    exitGuideMode() {
        let finished = false;
        if (this.getNextIndex().stepIndex === finishIndex) {
            finished = true;
        }
        this.setMode(TRAIN_MODE); //切换到练习模式
        this.stepAbort();
        if (this.actionIndex > -1 && this.actionIndex < this.steps[this.stepIndex].actions.length - 1) { //引导到一半时退出到，显示"重新引导"按钮
            let card = tipsToCard(this.actionIndex, [
                '当前步骤尚未引导完毕，是否重新引导当前步骤',
                {...BUTTONS.REENTER_GUIDE_MODE, stepIndex: this.stepIndex}
            ])
            this.insertCard(this.stepIndex, card, true);
            this.showButtons([{...BUTTONS.REENTER_GUIDE_MODE, stepIndex: this.stepIndex}]); //显示重新引导按钮
        }else {
            this.showButtons([]);
        }
        this.addContinueButton();
        /*
        if (finished) {
            event.once(EVENTS.TASK_GUIDE_PROJECT_SAVED, () => {
                this.goNext();
            });
        }*/
        //this.saveProjectToModifiedProject(); //将当前项目覆盖到自己的副本
    }


    /**
     * 终止引导
     */
    stepAbort() {
        event.emit(EVENTS.STEP_ABORT);
        event.removeAllListeners(EVENTS.STEP_ABORT);
        event.emit(EVENTS.CLEAR_COVER);
    }

    loadInitProject(stepIndex) {
        if (stepIndex > -1 && stepIndex < this.steps.length) {
            if (this.steps[stepIndex].init !== undefined) {
                this.currentInit = this.steps[stepIndex].init; //记录最后的初始化项目的id
                /*
                event.once(EVENTS.PROJECT_LOADED_FINISH, () => {
                    this.saveProjectToModifiedProject(); //初始化项目加载后，保存到改编项目中，这样就算中途刷新页面退出，重新载入时到modified的项目也是正确的。
                });
                 */
                this.blocksMap.clear(); //切换项目时，清空映射
                event.emit(EVENTS.TASK_LOAD_INIT_PROJECT, this.steps[stepIndex].init);
            }else
                this.showError("step中不存在init");
        }else {
            this.showError("step index超出范围：" + stepIndex);
        }
    }

    loadModifiedProject() {
        event.emit(EVENTS.TASK_LOAD_MODIFIED_PROJECT);
    }

    saveProjectToModifiedProject() {
        event.emit(EVENTS.TASK_SAVE_PROJECT_TO_MODIFIED_PROJECT);
    }

    showError(msg) {
        showMessage(msg);
        this.insertTips({stepIndex: this.stepIndex, actionIndex: this.actionIndex}, msg);
        console.error(msg);
    }

    //通过别名查询原始id
    getBlockId(blockName) {
        const found = this.blocksMap.get(blockName);
        if (!found) {
            return blockName;
        }
        return found;
    }

    //给积木块设置别名
    setBlockId(blockName, blockId) {
        if (this.blocksMap.get(blockName)) {
            console.warn(`blocksMap 中已有 ${blockName} 块，请确认脚本！`);
        }
        this.blocksMap.set(blockName, blockId);
    }
    //返回下一步{stepIndex, actionIndex}
    getNextIndex() {
        if (this.stepIndex === -1) return {stepIndex: -1, actionIndex: -1};
        if (this.actionIndex === -2) return {stepIndex: this.stepIndex, actionIndex: -1}; //下一步执行step本身
        if (this.stepIndex >= this.steps.length) { //溢出
            return {stepIndex: finishIndex, actionIndex: finishIndex};
        }
        let res = this.lastActionRes;
        if (res) { //如果上一步有返回值，根据返回值选择下一步
            if (typeof(res) == 'object') {
                if (res.goto) { //跳转步骤
                    let next = this.getIndexByName(res.goto);
                    if (next) {
                        return next;
                    }
                }
            }else if (typeof(res) == 'string') { //返回字符串类型时，默认表示goto
                let next = this.getIndexByName(res);
                if (next) {
                    return next;
                }
            }
        }

        let step = this.steps[this.stepIndex];
        if (step) {
            if (step.actions && step.actions.length - 1 > this.actionIndex) { //当前Step后面还有action
                if (this.mode === TRAIN_MODE) {
                    if (this.isShowTips) { //显示提示信息
                        for (let i = this.actionIndex + 1; i < step.actions.length; ++i) {
                            if (step.actions[i].isTips) {
                                return {stepIndex: this.stepIndex, actionIndex: i};
                            }
                        }
                    }
                }else { //GUIDE_MODE
                    return {stepIndex: this.stepIndex, actionIndex: this.actionIndex + 1};
                }
            }
            if (this.steps.length - 1 > this.stepIndex) { // 如果后面还有Step
                return {stepIndex: this.stepIndex + 1, actionIndex: -1};
            }
            // 如果后面没有步骤了，返回 -1
            return {stepIndex: finishIndex, actionIndex: finishIndex};
        }else {
            return {stepIndex: finishIndex, actionIndex: finishIndex};
        }
    }

    /**
     * 根据名称跳转到某个action或step
     * @param name step或action到名称，制作guide脚本的时候不要出现重名
     * @returns {{actionIndex: number, stepIndex: number}}
     */
    getIndexByName(name) {
        if (!name) return undefined;
        if (name === finishName) {
            return {stepIndex: finishIndex, actionIndex: finishIndex};
        }
        if (name === selfName) {
            return {stepIndex: this.stepIndex, actionIndex: this.actionIndex};
        }
        for (let i = 0; i < this.steps.length; ++i) {
            if (this.steps[i].name === name) { //step本身匹配到
                return {stepIndex: i, actionIndex: -1};
            }else if (this.steps[i].actions) { //其中的action匹配到
                for (let j = 0; j < this.steps[i].actions.length; ++j) {
                    if (this.steps[i].actions[j].name === name) {
                        return {stepIndex: i, actionIndex: j};
                    }
                }
            }
        }
        return undefined;
    }

    /**
     * 跳到某个aciton或step
     * @param name
     */
    goto(name) {
        const index = this.getIndexByName(name);
        if (index === undefined) {
            this.showError('不存在名为「' + name + '」的步骤')
        }else {
            if (index.stepIndex != this.stepIndex) {
                event.emit(EVENTS.STEP_SWITCHED_STEP);
            }
            this.setIndex(index);
            this.runStep();
        }

    }

    currentStep() {
        if (this.steps && this.steps.length > this.stepIndex) {
            return this.steps[this.stepIndex];
        }else {
            return undefined;
        }
    }
    /**
     * 跳到下一步
     */
    goNext(mode) {
        const nextIndex = this.getNextIndex();
        if (nextIndex.stepIndex != this.stepIndex && nextIndex.stepIndex != 0) {
            event.emit(EVENTS.STEP_SWITCHED_STEP);
        }
        this.setIndex(nextIndex);
        this.runStep(mode);
    }

    /**
     * 根据step名称查找step的index
     */
    getStepIndexByName(name) {
        if (name === finishName) {
            return finishIndex;
        }
        return this.steps.findIndex(s => s.name === name);
    }

    /**
     * 获取ChatStep
     * @param stepIndex
     */
    getChatStepByIndex(stepIndex) {
        let chatStep;
        for (let i = this.chatSteps.length - 1; i >= 0; --i) {
            if (this.chatSteps[i].stepIndex === stepIndex) {
                chatStep = this.chatSteps[i];
                break;
            }
        }
        return chatStep;
    }

    /**
     * 获取当前步骤的数据
     */
    getCurrentActionData() {
        const step = this.steps[this.stepIndex];
        if (step) {
            if (this.actionIndex > -1 && step.actions && step.actions.length > this.actionIndex) {
                return step.actions[this.actionIndex];
            }else { //step本身为当前步骤
                this.actionIndex = -1;
                return step;
            }
        }
        return undefined;
    }

    /**
     * 设置当前step和action
     * @param stepIndex
     * @param actionIndex
     */
    setIndex({stepIndex, actionIndex}) {
        this.stepIndex = stepIndex;
        this.actionIndex = actionIndex;
    }


    /**
     * 当接收到GAME_FINISH消息时，对状态进行校验
     * @param status
     */
    doValidate(e) {
        if (this.steps[this.stepIndex] && this.steps[this.stepIndex].validator) {
            const validator = this.steps[this.stepIndex].validator;
            if (e.type === 'GAME_FINISH') {
                if (validator[e.status]) { //捕获到有校验动作的消息
                    if (typeof(validator[e.status]) == 'string') {
                        this.insertTips({stepIndex: this.stepIndex, actionIndex: this.actionIndex}, validator[e.status]);
                        if (e.status === 'success') {
                            this.steps[this.stepIndex].validated = true; //标记当前步骤已经完成验证
                            this.addContinueButton();
                        }
                    }else {
                        this.runAction(validator[e.status]);
                    }
                }else {
                    console.error('未知的Game Event：', e);
                }

            }
        }
    }

    /**
     * 将card插入到聊天数据中
     * 如果stepIndex不存在，新建新的step
     * @param stepIndex
     * @param card
     * @param silent 是否播报语音
     * @return true插入成功，false插入失败或者重复
     */
    insertCard(stepIndex, card, silent) {
        let chatStep = undefined;
        if (this.chatSteps.length > 0) {
            let lastChatStep = this.chatSteps[this.chatSteps.length - 1];
            if (lastChatStep.stepIndex === stepIndex) {
                if (lastChatStep.cards.length > 0) {
                    let tmpCard = {...card};
                    tmpCard.id = lastChatStep.cards[lastChatStep.cards.length - 1].id;
                    if (compareObject(lastChatStep.cards[lastChatStep.cards.length - 1], tmpCard)) { //相同的card，可能是重复运行步骤产生，不重复插入
                        card.id = tmpCard.id;
                        if (!silent && this.mode !== BATCH_TIPS_MODE) {
                            cardToSpeak(card); //播报语音
                        }
                        return false;
                    }
                }
                chatStep = this.chatSteps[this.chatSteps.length - 1] = {...lastChatStep};
            }else if (lastChatStep.stepIndex < stepIndex) { //末尾添加
                chatStep = {stepIndex, cards: []};
                this.chatSteps.push(chatStep);
            }else { //插入到中间step
                for (let i = this.chatSteps.length - 1; i >= 0; --i) {
                    if (this.chatSteps[i].stepIndex === stepIndex) {
                        chatStep = this.chatSteps[i] = {...this.chatSteps[i]};
                        break;
                    }
                }
            }
        }else { //第一个step
            chatStep = {stepIndex, cards: []};
            this.chatSteps.push(chatStep);
        }
        if (chatStep) {
            if (!silent && this.mode !== BATCH_TIPS_MODE) {
                cardToSpeak(card); //播报语音
            }
            if (card.id === undefined) {
                card.id = this.cardId++;
            }
            let i;
            for (i = chatStep.cards.length - 1; i > -1; --i) {
                if (chatStep.cards[i].actionIndex <= card.actionIndex) {
                    break;
                }
            }
            if (i > -1) {
                chatStep.cards.splice(i + 1, 0, card);
            }else {
                chatStep.cards.push(card);
            }
            window.store.dispatch(setChatSteps([...this.chatSteps]));
            return true;
        }else {
            return false;
        }
    }

    /**
     * 替换card，并触发rerender
     * @param stepIndex
     * @param card
     */
    replaceCard(stepIndex, card) {
        if (card.id === undefined) {
            this.showError('替换的card的id必须要指定');
            return;
        }
        let chatStep = undefined;
        if (this.chatSteps.length > 0) {
            let lastChatStep = this.chatSteps[this.chatSteps.length - 1];
            if (lastChatStep.stepIndex === stepIndex) {
                chatStep = this.chatSteps[this.chatSteps.length - 1] = {...lastChatStep};
            }else if (lastChatStep.stepIndex < stepIndex) { //末尾添加
                this.showError('stepIndex溢出');
            }else { //插入到中间step
                for (let i = this.chatSteps.length - 1; i >= 0; --i) {
                    if (this.chatSteps[i].stepIndex === stepIndex) {
                        chatStep = this.chatSteps[i] = {...this.chatSteps[i]};
                        break;
                    }
                }
            }
        }
        if (chatStep) {
            for (let i = 0; i < chatStep.cards.length; ++i) {
                if (chatStep.cards[i].id === card.id) { //找到对应的card
                    chatStep.cards[i] = card;
                    break;
                }
            }
        }
        window.store.dispatch(setChatSteps([...this.chatSteps]));
    }

    /**
     * 插入一个tips
     * @param stepIndex
     * @param actionIndex
     * @param tips
     * @param silent
     */
    insertTips({stepIndex, actionIndex}, tips, silent) {
        this.insertCard(stepIndex, tipsToCard(actionIndex, tips), silent);
    }

    /**
     * 我的回复
     * @param stepIndex
     * @param actionIndex
     * @param text
     */

    insertReply({stepIndex, actionIndex}, text) {
        let card = tipsToCard(actionIndex, text);
        card.reply = 1;
        this.insertCard(stepIndex, card, true);
    }

    /**
     * 运行一个action
     * @param actionData
     */
    runAction(data) {
        if (actions[data.action] == undefined) {
            this.showError('action不存在：' + data.action);
            return;
        }
        if (!data.params) data.params = {};
        this.isActionRunning = true;
        this.showButtons([]);
        actions[data.action](data.params, this.mode, {stepIndex: this.stepIndex, actionIndex: this.actionIndex}).then(res => {
            if (this.mode === GUIDE_MODE && this.hasButton(BUTTONS.CONTINUE)) {
                this.isActionRunning = true;
            }else {
                this.isActionRunning = false;
            }
            this.lastActionRes = res;
            if (res && res.switchMode !== undefined && res.switchMode != this.mode) {
                if (res.switchMode == GUIDE_MODE) {
                    //this.handleEnterGuideMode({stepIndex: this.stepIndex});
                    this.enterGuideMode();
                }else if (res.switchMode == TRAIN_MODE) {
                    this.exitGuideMode();
                }
                return;
            }
            if (this.mode === GUIDE_MODE) { //如果是手把手引导模式，自动开始运行下一步，否则等待event触发
                if (!this.hasButton(BUTTONS.CONTINUE) || (res && res.autoNext)) { //没有生成「继续」按钮的，或者resolve中明确表示要自动进入下一步的，自动进入下一步
                    setTimeout(this.handleContinue, 0);
                }
            }else if (res && res.goto) { //练习模式，只有遇到步骤跳转时，才自动跳转
                if (!this.hasButton(BUTTONS.CONTINUE)) {
                    setTimeout(this.goNext, 0); //这里直接使用goNext而不是handleContinue，因为handleContinue中会被validator阻止
                }
            }else { //非引导模式下，确保存在"继续"按钮
                this.addContinueButton();
            }
        }).catch(error => {
            this.isActionRunning = false;
            if (error === 'Step Abort') { //被外部终止
                Audio.stop();
                //showMessage('已退出智能引导模式');
            }else {
                console.error('步骤运行异常', data.action, error);
                if (this.mode === GUIDE_MODE) {
                    renderConfirmModal({
                        title: "操作失败，点击『重试』，或『终止』当前步骤",
                        msg: error,
                        closeText: '终止',
                        confirmText: '重试',
                        confirmText2: '下一步',
                        onClose: ()=>{
                            renderConfirmModal({
                                title:"确认要终止引导模式吗？",
                                closeText:'确认',
                                confirmText:'取消',
                                onClose:() => {
                                    this.exitGuideMode();
                                },
                                onConfirm:()=>{
                                    this.runStep();
                                }
                            })
                        },
                        onConfirm: () => {
                            //resolve(this.runStep(index, stepsArr, stepsMap));
                            this.runStep();
                        },
                        onConfirm2: () => {
                            this.goNext();
                        }
                    });
                }else {
                    this.addContinueButton();
                }

            }
        });
    }

    /**
     * 显示纯提示
     * @param data
     * @returns {*}
     */
    showTips(stepIndex, actionIndex, data) {
        let card = undefined;
        if (data.tips) {
            card = tipsToCard(actionIndex, data.tips);
        }else if (data.action) { //从历史记录中点击「提示我」时，会执行action的纯提示模式
            if (actions[data.action] == undefined) {
                this.showError('action不存在：' + data.action);
                return;
            }
            if (!data.params) data.params = {};
            actions[data.action](data.params, BATCH_TIPS_MODE, {stepIndex, actionIndex}).then(res => {

            }).catch( error => {
                let tempCard = tipsToCard(actionIndex, error);
                this.insertCard(stepIndex, tempCard);
            });
        }else if (data.params && data.params.tips) {
            card = tipsToCard(actionIndex, data.params.tips);
        }else {
            let tempCard = tipsToCard(actionIndex, '这个步骤需要开动你聪明的脑筋，小奥无法给你提供更多提示哦');
            this.insertCard(stepIndex, tempCard);
        }
        if (card) {
            if (actionIndex === -1) { //Step的第一个卡片
                const hasGuideAction = !!data.actions;
                /*
                let hasTips = false;
                let hasGuideAction = false;
                if (actionIndex === -1 && data.actions) {
                    for (let i = 0; i < data.actions.length; ++i) {
                        if (data.actions[i].isTips) {
                            hasTips = true;
                        }else {
                            hasGuideAction = true;
                        }
                    }
                }
                 */
                let buttons = [];
                if (data.moreTips) {
                    buttons.push({...BUTTONS.SHOW_TIPS, stepIndex});
                }
                if (hasGuideAction) {
                    if (data.init === undefined) {
                        console.error('缺少init字段', data);
                    }
                    if (this.mode == GUIDE_MODE) {
                        buttons.push({...BUTTONS.REENTER_GUIDE_MODE, stepIndex});
                    }else {
                        buttons.push({...BUTTONS.ENTER_GUIDE_MODE, stepIndex});
                    }
                }
                if (buttons) {
                    card.lines.push({buttons});
                }
            }
            this.insertCard(stepIndex, card);
        }
    }

    getProgress() {
        let progress = 0;
        if (this.stepIndex === finishIndex) {
            progress = 1;
        }else if (this.steps.length > 0) {
            progress = this.stepIndex / this.steps.length;
        }
        return progress;
    }
    /**
     * 运行当前Step
     * @param mode 可以强行指定运行模式，此时会忽略action里指定的mode
     */
    runStep(mode) {
        this.lastActionRes = undefined;
        if (mode !== undefined) this.setMode(mode);
        window.store.dispatch(setStepProgress(this.getProgress()));
        if (this.stepIndex === finishIndex || this.stepIndex >= this.steps.length) { //没有更多步骤
            if (this.mode === GUIDE_MODE) {
                this.exitGuideMode();
            }
            event.emit(EVENTS.STEP_GUIDE_FINISH);
            console.log(EVENTS.STEP_GUIDE_FINISH);
            return;
        }
        const actionData = this.getCurrentActionData();

        this.stepAbort(); //尝试清理之前的步骤
        Audio.stop();
        //先清空操作按钮，action中会生成
        /*
        if (this.mode === GUIDE_MODE) {
            this.showButtons([BUTTONS.EXIT_GUIDE_MODE]);
        }else {
            let hasGuideAction = false;
            if (actionData.action) {
                hasGuideAction = true;
            }else if (this.actionIndex === -1 && actionData.actions) {
                for (let i = 0; i < actionData.actions.length; ++i) {
                    if (actionData.actions[i].action) {
                        hasGuideAction = true;
                        break;
                    }
                }
            }
            if (hasGuideAction) {
                this.showButtons([BUTTONS.ENTER_GUIDE_MODE]);
            }
        }*/
        //练习模式不允许执行actions里的步骤
        if (this.mode == TRAIN_MODE && this.actionIndex > -1) {
            console.warn('练习模式下，不能执行actions里的步骤');
            return;
        }
        if (actionData) {
            //step中明确要求强制切换模式
            if (mode === undefined && actionData.mode && this.mode != actionData.mode) {
                if (actionData.mode == GUIDE_MODE) {
                    //this.handleEnterGuideMode({stepIndex: this.stepIndex});
                    this.enterGuideMode();
                }else if (actionData.mode == TRAIN_MODE) {
                    this.exitGuideMode();
                }
                return;
            }
            //引导模式或者是第一个步骤有init并且当前项目不是改编项目，载入init项目
            if (this.mode === GUIDE_MODE || (this.stepIndex == 0 && window.store.getState().scratchGui.projectState.projectId != this.modifiedProjectId)) {
                //当前步骤有init，并且当前项目不是init项目，先载入
                if (this.actionIndex === -1 && actionData.init !== undefined &&
                    (actionData.init != window.store.getState().scratchGui.projectState.projectId)) {
                    event.once(EVENTS.PROJECT_LOADED_FINISH, this.doRunStep);
                    this.loadInitProject(this.stepIndex);
                    return;
                }
            }
            //隐藏指定的块
            if (actionData.hideBlocks) {
                for (let i = 0; i < actionData.hideBlocks.length; ++i) {
                    const node = document.querySelector(`[data-id="${actionData.hideBlocks[i]}"]`);
                    if (node) {
                        if (node.style)
                            node.style.display = 'none';
                    }else {
                        console.warn('需要隐藏的积木对象不存在：' + actionData.hideBlocks[i]);
                    }
                }
            }
            //显示指定的块
            if (actionData.showBlocks) {
                for (let i = 0; i < actionData.showBlocks.length; ++i) {
                    const node = document.querySelector(`[data-id="${actionData.showBlocks[i]}"]`);
                    if (node) {
                        if (node.style)
                            node.style.display = '';
                    }else {
                        console.warn('需要显示的积木对象不存在：' + actionData.showBlocks[i]);
                    }
                }
            }
            const doRun = () => {
                if (actionData.action) { //常规actions
                    this.runAction(actionData);
                }else if (actionData.tips) { //纯tips
                    this.showButtons([]);
                    this.showTips(this.stepIndex, this.actionIndex, actionData);
                    this.addContinueButton();
                    if (this.mode == GUIDE_MODE) {
                        renderCover(ZINDEX_FOCUS_COVER, OPACITY_FOCUS_COVER);
                    }
                }else { //跳过空白步骤
                    this.goNext();
                }
            }
            //切换舞台区模式
            if (actionData.stageMode != undefined) {
                stageMode({mode: actionData.stageMode}, this.mode, {stepIndex: this.stepIndex, actionIndex: this.actionIndex}).then(() => {
                    doRun();
                });
            }else {
                doRun();
            }

        }

    }

    /**
     * 显示更多提示
     */
    moreTips(stepIndex) {
        let step = this.steps[stepIndex];
        if (!step) {
            this.showError('stepIndex错误');
            return;
        }

        //使按钮失效
        let chatStep;
        for (let i = this.chatSteps.length - 1; i >= 0; --i) {
            if (this.chatSteps[i].stepIndex === stepIndex) {
                chatStep = this.chatSteps[i] = {...this.chatSteps[i]};
                break;
            }
        }
        if (chatStep.cards) {
            chatStep.cards = [...chatStep.cards];
            let buttonsLine = {...chatStep.cards[0].lines.pop()};
            buttonsLine.buttons = [...buttonsLine.buttons];
            for (let i = 0; i < buttonsLine.buttons.length; ++i) {
                if (buttonsLine.buttons[i].event === BUTTONS.SHOW_TIPS.event) {
                    buttonsLine.buttons[i] = {...buttonsLine.buttons[i], disable: true}
                    break;
                }
            }
            chatStep.cards[0].lines.push(buttonsLine);
        }

        let card;
        if (step.moreTips) {
            card = tipsToCard(-1, step.moreTips);
        }else {
            card = tipsToCard(-1, '这个步骤需要开动你聪明的脑筋，小奥无法给你提供更多提示哦');
        }
        let buttons = [];
        if (step.actions) {
            const hasGuideAction = !!step.actions;
            /*
            let hasGuideAction = false;
            for (let i = 0; i < step.actions.length; ++i) {
                if (step.actions[i].action) {
                    hasGuideAction = true;
                    break;
                }
            }*/

            if (hasGuideAction) {
                if (!step.init) {
                    console.error('缺少init字段', step);
                }
                if (this.mode == GUIDE_MODE) {
                    buttons.push({...BUTTONS.REENTER_GUIDE_MODE, stepIndex});
                }else {
                    buttons.push({...BUTTONS.ENTER_GUIDE_MODE, stepIndex});
                }
            }
        }

        if (buttons) {
            card.lines.push({buttons});
        }
        this.insertCard(stepIndex, card);
        /* 旧的根据actions产生tips的逻辑
        if (stepIndex === this.stepIndex) { //当前Step的提示
            this.isShowTips = true;
            if (step.actions) {
                this.goNext();
            }else {
                let card = tipsToCard(-1, '这个步骤需要开动你聪明的脑筋，小奥无法给你提供更多提示哦');
                this.insertCard(stepIndex, card);
            }
        }else { //历史Step的提示，只连续输出tips，不运行action
            if (step.actions) {
                let lastMode = this.mode;
                let lastButtons = this.buttons;
                this.setMode(BATCH_TIPS_MODE);
                //TODO 使「提示我」按钮失效
                for (let i = 0; i < step.actions.length; ++i) {
                    if (step.actions[i].isTips) {
                        this.showTips(stepIndex, i, step.actions[i]);
                    }
                }
                this.setMode(lastMode);
                this.showButtons(lastButtons);
            }
        }*/
    }


    //对当前项目保存副本
    saveCopy() {
        event.once(EVENTS.PROJECT_CREATED_FINISH, () => {
            setTimeout(() => {
                console.log('projectId: ' + window.store.getState().scratchGui.projectState.projectId);
            }, 500);
        });
        window.store.dispatch(saveProjectAsCopy());

    }
}

window.stepsRuntime = new StepsRuntime();
window._Blockly = ScratchBlocks; //导出仅仅是为了方便调试
window.run = window.stepsRuntime.run.bind(window.stepsRuntime); //运行脚本
window.loadInitProject = window.stepsRuntime.loadInitProject.bind(window.stepsRuntime); //加载初始项目
window.saveCopy = window.stepsRuntime.saveCopy.bind(window.stepsRuntime);

/*
window.trace = function trace(count) {
    let caller = arguments.callee.caller;
    let i = 0;
    console.log('***----------------*** ' + (i + 1));
    count = count || 10;
    while (caller && i < count) {
        console.log(caller.toString());
        caller = caller.caller;
        ++i;
        console.log('***----------------*** ' + (i + 1));
    }
}
 */

export {
    BUTTONS,
    tipsToCard,
    cardToText,
    cardToSpeak
};

export default StepsRuntime;
